import React, { useMemo } from 'react'

import { Table, TableRow } from '../../../../../components/pdf/Table'
import { TableColLabelValue } from '../../../../../components/pdf/TableHelpers'
import Image from '../../../../../components/pdf/Image'
import Separator from '../../../../../components/pdf/Separator'
import Text from '../../../../../components/pdf/Text'
import View from '../../../../../components/pdf/View'
import { mountValidityDateRange, getPlaceNames, findReplyByQuestionName } from '../../_helpers/pdfHelpers'

const CoverSection = ({ serviceOrder }) => {
  const placeNames = getPlaceNames(serviceOrder.place.name)

  const dateValidity = useMemo(() => {
    const validity = mountValidityDateRange(serviceOrder)
    return validity
  }, [serviceOrder])

  return (
    <View pageBreakAfter>
      <Separator weight={90} />
      <Text bold size="h4" align="center">
        UNIMED
      </Text>

      <Separator weight={15} />
      <Image src="/pdfs/template-sso/unimed-logo.png" maxWidth={145} style={{ margin: 'auto' }} ignoreFixedSize />
      <Separator weight={15} />

      <Text bold size="h5" align="center">
        AET
      </Text>

      <Text bold size="h5" align="center">
        Análise Ergonômica do Trabalho
      </Text>

      <Separator weight={15} />

      <Table width="70%" center>
        <TableRow>
          <TableColLabelValue label="UNIORG" value={placeNames.placeCode} colSpan={2} />
        </TableRow>

        <TableRow>
          <TableColLabelValue label="NOME DO ESTABELECIMENTO" value={placeNames.placeName} colSpan={2} />
        </TableRow>

        <TableRow>
          <TableColLabelValue
            label="DATA DA EMISSÃO"
            value={`${dateValidity.month}/${dateValidity.currentYear} - ${dateValidity.month}/${dateValidity.expiryYear}`}
          />
          <TableColLabelValue label="REVISÃO" value="00" />
        </TableRow>

        <TableRow>
          <TableColLabelValue
            label="RESPONSÁVEL PELO PGR"
            value={findReplyByQuestionName(serviceOrder.replies, 'Representante da empresa').value.name}
            colSpan={2}
          />
        </TableRow>
      </Table>

      <Separator weight={15} />

      <Text bold size="small" align="center">
        {`${dateValidity.month}/${dateValidity.currentYear}`}
      </Text>

      <Separator weight={120} />
    </View>
  )
}

export default CoverSection
